import { CONST } from "../../CONST";
import { BurgerScene } from "../../scenes/BurgerScene";
import { IngredientConfig, IngredientSpawner } from "./IngredientSpawner";


const CONFIG = {
    dragDepth: 20,
    spawnMove: {
        duration: 500,
        ease: "Quad.easeOut",
    },

    burgerMove: {
        duration: 200,
        ease: "Back.easeIn",
    },

    fade: {
        duration: 500,
        ease: "Quad.easeInOut",
    },

    shadowOffset: {
        x: 6.5,
        y: 4,
    }
}

export class Ingredient extends Phaser.GameObjects.Image{
    private spawner : IngredientSpawner;
    public config : IngredientConfig; 

    private moveTween !: Phaser.Tweens.Tween;
    private fadeTween !: Phaser.Tweens.Tween;

    public imgShadow : Phaser.GameObjects.Image;

    private addedToBurger = false; 

    public isDragging = false;


    constructor(config: IngredientConfig, scene: BurgerScene, spawner: IngredientSpawner){
        super(scene, config.spawn.x, config.spawn.y, config.texture);

        this.config = config;
        this.spawner = spawner;

        this.setInteractive({useHandCursor: true, draggable: true, pixelPerfect: true});
        this.setAlpha(0);
        this.setOrigin(config.origin.x, config.origin.y);
        this.fade(true);
        this.setDepth(config.depth);

        this.imgShadow = scene.add.image(0, 0, this.config.shadow_texture)            
            .setOrigin(this.originX, this.originY)
            .setTint(0x353535)
            .setAlpha(0.3 * this.alpha);
        this.updateShadow();

        this.on('dragstart', (pointer: any, dragX: number, dragY: number) => {
            this.isDragging = true;
            this.handleDragStart(scene);
         });
    
         this.on('drag', (pointer: any, dragX: number, dragY: number) => {
             if (!this.isDragging) return;
            this.handleDrag(dragX, dragY);
        });
   
        this.on('dragend', (pointer: any, dragX: number, dragY: number, dropped: boolean) => {
            this.isDragging = false;
            this.handleDragEnd(scene);
        });

        scene.add.existing(this);
    }

    private updateShadow(){
        this.imgShadow.x = this.x + CONFIG.shadowOffset.x;
        this.imgShadow.y = this.y + CONFIG.shadowOffset.y;
        this.imgShadow.setDepth(this.depth - 2);

        if (!(this.isDragging || this.addedToBurger)){
            this.imgShadow.setAlpha(0.3 * this.alpha);
        }
    }

    private handleDragStart(scene: BurgerScene){
        this.setDepth(CONFIG.dragDepth);
        this.updateShadow();
        this.fadeShadow(false);

        scene.onIngredientDrag(true);

        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});
    }

    private handleDrag(x: number, y: number){
        this.setPosition(x, y);

        this.updateShadow();
    }

    private handleDragEnd(scene: BurgerScene){
        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});

        this.spawner.onIngredientDropped(this.x, this.y);
        this.updateShadow();

        scene.onIngredientDrag(false);
    }

    public addToBurger(container: Phaser.GameObjects.Container, pos: {x: number, y: number}, firstIngredient: boolean){
        if (firstIngredient){
            this.fadeShadow(true);
        }
        this.addedToBurger = true;

        this.disableInteractive();

        //Move to burger coordinates
        this.x -= container.x;
        this.y -= container.y;

        if (this.moveTween){
            this.moveTween.stop();
        }

        this.moveTween = this.scene.tweens.add({
            targets: this, 
            x: pos.x,
            y: pos.y, 
            duration: CONFIG.burgerMove.duration,
            ease: CONFIG.burgerMove.ease,
            onUpdate: () => {
               this.updateShadow();
            }
        });
    }

    public moveToSpawn(){
        if (this.moveTween){
            this.moveTween.stop();
        }

        this.moveTween = this.scene.tweens.add({
            targets: this, 
            x: this.config.spawn.x,
            y: this.config.spawn.y, 
            duration: CONFIG.spawnMove.duration,
            ease: CONFIG.spawnMove.ease,
            onUpdate: () => {
                this.setDepth(this.config.depth);
                this.updateShadow();
            }
        });

        this.fadeShadow(true);

    }

    public getIngredientType(){
        return this.config.ingredient;
    }

    private fade(fadeIn: boolean){
        if (this.fadeTween){
            this.fadeTween.stop();
        }

        this.fadeTween = this.scene.tweens.add({
            targets: this, 
            alpha: fadeIn ? 1 : 0,
            duration: CONFIG.fade.duration,
            ease: CONFIG.fade.ease,
            onUpdate: () => {
                this.updateShadow();
            }
        });
    }
    private fadeShadow(fadeIn: boolean){
       this.scene.tweens.add({
            targets: this.imgShadow,
            alpha: fadeIn ? 0.3 : 0,
            duration: 250,
            ease: CONFIG.fade.ease,
        });
    }
}